import React, { useRef, useEffect, useState } from 'react';
import classnames from 'classnames';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const Modal = ({ className, show = false, children, title, onClose, nodeId, closeBtn, closeOnOuterClick = true }) => {
  const classes = classnames(className, {
    modal: true,
    ['modal--show']: show,
  });
  const [indexFocus, setIndexFocus] = useState(0);
  const indexFocusRef = useRef(indexFocus);
  const focusModal = useRef(null);

  document.addEventListener('keydown', (event) => {
    event.key === 'Escape' ? onClose() : '';
  });

  useEffect(() => {
    show && focusModal.current.focus();
  }, [show]);

  useEffect(() => {
    document.addEventListener('keydown', handleKeydown);
    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  const setIndexFocusRef = data => {
    indexFocusRef.current = data;
    setIndexFocus(data);
  };

  const handleKeydown = evt => {
    const listener = keyListenersMap.get(evt.keyCode);
    return listener && listener(evt);
  };
  //Trap focus within modal
  const handleTab = evt => {
    const modal = document.getElementsByClassName('modal--show');
    const modalElements = modal[0].querySelectorAll('section')[0].querySelectorAll('[href], a, button[role="button"], button[type="submit"], textarea, select, input:not([type="radio"]):not([type="checkbox"]), [tabindex]:not([tabindex="-1"])');
    let total = modalElements.length;
    let activeIndex = evt.target?.id !== '' ? Array.from(modalElements).findIndex(e => e.id === evt.target.id) : indexFocusRef.current;
    if (modal[0] === focusModal.current.parentElement) {
      if (!evt.shiftKey) {
        activeIndex + 1 === total ? activeIndex = 0 : activeIndex += 1;
        modalElements[activeIndex].focus();
        setIndexFocusRef(activeIndex);
        return evt.preventDefault();
      }
      if (evt.shiftKey) {
        activeIndex - 1 < 0 ? activeIndex = total - 1 : activeIndex -= 1;
        modalElements[activeIndex].focus();
        setIndexFocusRef(activeIndex);
        return evt.preventDefault();
      }
    } else {
      return evt.preventDefault();
    }
  };

  const keyListenersMap = new Map([
    [9, handleTab],
  ]);

  const modalRender = (
    <div className={classes}>
      <div className="modal__overlay" onClick={closeOnOuterClick && onClose} />
      <section className="modal__body" aria-modal="true" role="dialog" tabIndex="0" aria-label="Card Modal" ref={focusModal}>
        <button onClick={onClose} className="modal__close" tabIndex="0" role="button" aria-label="Close">
          { closeBtn ? (closeBtn) : (<span className="default-close" tabIndex="0">X</span>) }
        </button>
        { title ? <div className="modal__header">{title}</div> : null }
        <div className="modal__content">{children}</div>
      </section>
    </div>
  );

  if (nodeId) {
    return createPortal(modalRender, document.getElementById(nodeId));
  } else {
    return modalRender;
  }
};

Modal.propTypes = {
  className: PropTypes.string,
  show: PropTypes.bool,
  children: PropTypes.any,
  title: PropTypes.any,
  onClose: PropTypes.func,
  nodeId: PropTypes.any,
  closeBtn: PropTypes.any,
  closeOnOuterClick: PropTypes.bool
};

export default Modal;
